import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { loadContractPreferenceServer, saveContractdPreferenceServer } from "src/docuclipper/api";

interface ViewState {
    view: string | null;
    loading: boolean;
    error: string | null;
}

const initialState: ViewState = {
    view: null,
    loading: false,
    error: null,
};

const slice = createSlice({
    name: "View",
    initialState,
    reducers: {
        setView(state, action: PayloadAction<string | null>) {
            state.view = action.payload;
        },
        load(state) {
            state.loading = true;
            state.error = null;
        },
        setError(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        setSuccess(state) {
            state.loading = false;
            state.error = null;
        },
    },
});

export const { setView, load, setError, setSuccess } = slice.actions;

export const loadViewPreference = () => async (dispatch) => {
    try {
        dispatch(load());
        const response = await loadContractPreferenceServer({ key: "uiView" });
        dispatch(setView(response?.value || null));
        dispatch(setSuccess());
    } catch (error: any) {
        console.error("Failed to load view preference:", error);
        dispatch(setError(error.message || "Failed to load view preference"));
    }
};

export const saveViewPreference = (view: string | null) => async (dispatch) => {
    try {
        dispatch(load());
        await saveContractdPreferenceServer({
            key: "uiView",
            value: view || "",
        });
        dispatch(setView(view));
        dispatch(setSuccess());
    } catch (error: any) {
        console.error("Failed to save view preference:", error);
        dispatch(setError(error.message || "Failed to save view preference"));
    }
};

export default slice.reducer; 